<template>
    <page-loader v-if="loadingStatus === 'loading'" />

    <div class="row" v-else>
        <div class="col-12 my-3">
            <div class="inner-box">
                <div class="inner-content">

                    <h4 class="mb-4"><b>References</b></h4>

                    <div v-if="references?.content_reference?.length">

                        <div
                            v-for="reference in references.content_reference"
                            :key="reference.id"
                            class="border rounded p-3 mb-2"
                        >
                            <div class="d-flex justify-content-between align-items-start">

                                <!-- Reference Text -->
                                <div class="flex-grow-1 pe-3 text-start">
                                    {{ reference.title }}
                                </div>

                                <!-- Button -->
                                <div v-if="reference.external_url">
                                    <a
                                        :href="reference.external_url"
                                        target="_blank"
                                        class="btn btn-sm btn-outline-primary"
                                    >
                                        View
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div v-else class="text-muted">
                        No references available
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getVikingReference } from "@/services/vikings";
import { ref, onMounted } from "vue";

const loadingStatus = ref("loading");
const references = ref({});

onMounted(async () => {
    references.value = await getVikingReference();
    loadingStatus.value = "loaded";
});
</script>